import { Attributes } from '@leverege/ui-attributes';
import ArrayUtil from '@leverege/array-util';
import Model from "../../models/RsrcFilterModel.js";
function create(options) {
  const {
    filterModel,
    objectType,
    onFilterModelChange
  } = options;
  const useSortBy = hooks => {
    hooks.getSortByToggleProps.push((props, data) => {
      const {
        column
      } = data;
      if (column.attribute) {
        const attr = Attributes.getAttribute(column.attribute.name, objectType);
        return {
          ...props,
          onClick: e => {
            toggleSort(e, {
              attribute: attr,
              filterModel,
              onFilterModelChange
            });
          }
        };
      }
      return props;
    });
    hooks.useInstance.push(instance => {
      const {
        flatHeaders
      } = instance;
      flatHeaders.forEach(column => {
        if (column.attribute) {
          const {
            attribute: {
              name
            }
          } = column;
          const {
            sorts = []
          } = filterModel;
          const attr = Attributes.getAttribute(name, objectType);
          const field = attr?.sourceOptions?.sortField;
          const columnSort = sorts.find(d => d.field === field);
          column.isSorted = !!columnSort;
          column.sortedIndex = sorts.findIndex(d => d.field === field);
          column.isSortedDesc = column.isSorted ? columnSort.order === 'desc' : undefined;
        }
      });
    });
  };
  return useSortBy;
}
function toggleSort(event, {
  attribute,
  filterModel,
  onFilterModelChange
}) {
  const {
    sorts = []
  } = filterModel;
  if (!attribute?.sourceOptions?.sortable || !attribute?.sourceOptions?.sortField) {
    return;
  }
  const currSortIndex = ArrayUtil.index(sorts, 'field', attribute.sourceOptions.sortField);
  const currSort = sorts[currSortIndex];
  const isMulti = event.shiftKey;
  const args = [];
  let action;
  let payload;
  if (!isMulti) {
    action = 'setSorts';
    if (!currSort) {
      payload = [{
        field: attribute.sourceOptions.sortField,
        order: 'asc',
        missing: '_first'
      }];
    } else if (currSort.order === 'asc') {
      payload = [{
        field: attribute.sourceOptions.sortField,
        order: 'desc',
        missing: '_last'
      }];
    } else {
      payload = [];
    }
    args.push(payload);
  } else if (!currSort) {
    action = 'addSort';
    payload = {
      field: attribute.sourceOptions.sortField,
      order: 'asc',
      missing: '_first'
    };
    args.push(payload);
  } else if (currSort.order === 'asc') {
    action = 'setSort';
    payload = {
      field: attribute.sourceOptions.sortField,
      order: 'desc',
      missing: '_last'
    };
    args.push(currSortIndex, payload);
  } else {
    action = 'removeSortAt';
    payload = currSortIndex;
    args.push(payload);
  }
  onFilterModelChange({
    value: Model[action](filterModel, ...args)
  });
}
export default {
  create
};